import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-generic-inline-messages',
    templateUrl: './generic-inline-messages.component.html',
    styleUrls: ['./generic-inline-messages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericInlineMessagesComponent implements OnInit {

  constructor(public appService: AppService) { }

  ngOnInit(): void {
    this.appService.showInlineMessage("success", null);
    this.appService.showInlineMessage("error", null);
  }

}
